import React from 'react';
import { Container, Grid, Box, Typography, Card, CardContent } from '@mui/material';

export const ProgressSection: React.FC = () => {
    return (
        <Box
            id="progress"
            sx={{
                py: { xs: 8, md: 12 },
            }}
        >
            <Container maxWidth="lg">
                <Typography
                    variant="h2"
                    sx={{
                        mb: 3,
                        textAlign: 'center',
                        background: 'linear-gradient(135deg, #5b4cdb 0%, #1e293b 100%)',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                    }}
                >
                    Progress & Assessment
                </Typography>

                <Typography
                    variant="body1"
                    sx={{
                        mb: 6,
                        textAlign: 'center',
                        color: 'text.secondary',
                        maxWidth: 800,
                        mx: 'auto',
                        lineHeight: 1.8,
                    }}
                >
                    We keep parents fully informed throughout the learning journey. Our programme includes
                    baseline assessments, regular progress updates, and timed mock examinations with detailed
                    feedback.
                </Typography>

                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card sx={{ height: '100%' }}>
                            <CardContent sx={{ p: 4 }}>
                                <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
                                    What's included
                                </Typography>
                                <Box component="ul" sx={{ pl: 2, m: 0 }}>
                                    {[
                                        'Initial baseline assessment',
                                        'Ongoing progress reports',
                                        'Timed mock exams',
                                        'Targeted improvement plans',
                                    ].map((item, index) => (
                                        <Typography
                                            component="li"
                                            key={index}
                                            variant="body2"
                                            sx={{ mb: 1.5, color: 'text.secondary', lineHeight: 1.7 }}
                                        >
                                            {item}
                                        </Typography>
                                    ))}
                                </Box>
                            </CardContent>
                        </Card>
                    </Grid>

                    <Grid size={{ xs: 12, md: 6 }}>
                        <Card sx={{ height: '100%' }}>
                            <CardContent sx={{ p: 4 }}>
                                <Typography variant="h5" sx={{ mb: 3, fontWeight: 600 }}>
                                    Our focus
                                </Typography>
                                <Typography variant="body1" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
                                    We identify gaps early, strengthen fundamentals, and practice exam-style questions
                                    so students feel calm and prepared.
                                </Typography>
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            </Container>
        </Box>
    );
};
